import { crudApi } from "../../../helpers/api_helper";
import { STATUS_RESERVA } from "../../../helpers/url_helper";

export default crudApi(STATUS_RESERVA);
